import React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { Text } from '@omilia/typography';

import { FixStyle } from 'components/styled';
import convoLogo from 'styles/images/Logo-Conversation-Studio-login.svg';

import {
  SForm,
  SFooter,
  SFooterText,
  SH3,
  SInner,
  SLayout,
  SExtraInfo,
  SExtraInfoText,
} from './styled';

interface Props extends RouteComponentProps {
  children: React.ReactNode | React.ReactElement;
  onSubmit: () => void;
  showExtra?: boolean;
}

const year = new Date().getFullYear();

const AuthLayout = ({ children, onSubmit, showExtra }: Props) => (
  <SLayout>
    <Helmet>
      <title>Omilia Conversation Studio</title>
    </Helmet>

    <ToastContainer
      hideProgressBar
      newestOnTop
      autoClose={10000}
      closeButton={false}
      draggable={false}
      position={toast.POSITION.TOP_RIGHT}
    />

    <section>
      <img alt="Conversation Studio logo" src={convoLogo} />

      <SH3>Enter a New World of Customer Service</SH3>
    </section>

    <SInner>
      <FixStyle />
      <SForm noValidate data-test="form" onSubmit={onSubmit}>
        {children}
      </SForm>
      {showExtra && (
        <SExtraInfo>
          <Text level={4}>Already have an account?</Text>
          <Link data-test="login-link" to="/sign_in">
            <SExtraInfoText level={4}>Log in</SExtraInfoText>
          </Link>
        </SExtraInfo>
      )}
    </SInner>

    <SFooter>
      <SFooterText level={4}>
        Copyright &copy; {year} Omilia Ltd. All Rights Reserved.
      </SFooterText>
    </SFooter>
  </SLayout>
);

export default withRouter(AuthLayout);
